import React, { useCallback, useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";

import { ssoAPI, signedIn } from "../../services/portalApi";
import { SignIn } from "./AccountPage";
import Footer from "../home/footer";
import "../booking/booking.css";

/* Only ever on to the forum's sign-in at Forge: nothing else is accepted. */
const FORUM_REQUEST = /^\/portal\/community\/connect\?sso=[A-Za-z0-9%+/=_-]+&sig=[0-9a-f]{64}$/;

/**
 * /account/continue?next=… — the community forum is shared with Forge and
 * signs in through Forge. A Makua guest who opened it lands on Forge's
 * sign-in, chooses "Continue with your Makua sign-in", and comes here:
 * we sign them in to Makua if needed, then hand them back to Forge.
 */
export default function ContinuePage() {
  const [params] = useSearchParams();
  const next = params.get("next") || "";
  const valid = FORUM_REQUEST.test(next);
  const [authed, setAuthed] = useState(signedIn());
  const [error, setError] = useState(valid ? "" : "This link is incomplete. Open the community again and choose to continue with Makua.");

  const go = useCallback(async () => {
    try { window.location.replace((await ssoAPI.handoff(next)).url); }
    catch (e) { setError(e.message); }
  }, [next]);

  useEffect(() => { if (valid && authed) go(); }, [valid, authed, go]);

  return (
    <>
      <div className="mk-page grain-bg-light">
        {error ? (
          <div className="mk-wrap">
            <p className="mk-eyebrow">Community</p>
            <h1 className="mk-title">We couldn't take you to the community.</h1>
            <p className="mk-muted mk-sub">{error}</p>
            <div className="mk-actions"><Link className="mk-btn mk-btn--primary" to="/account">Go to your account</Link></div>
          </div>
        ) : authed ? (
          <div className="mk-wrap"><p className="mk-muted" style={{ minHeight: "40vh" }}>Taking you to the community…</p></div>
        ) : (
          <SignIn
            eyebrow="Community"
            intro="Sign in with the email you booked with. You'll go straight on to the community."
            allowRegister={false}
            onDone={() => setAuthed(true)}
          />
        )}
      </div>
      <Footer />
    </>
  );
}
